<div id="profil" id="seitenanordnung" class="example-container">
  <div id="hauptcontent">
    <profil #profil *ngIf="seite == 'einsehen'"></profil>
    <app-rechnungen [kunde]="kunde" [mandant]="mandant" *ngIf="seite == 'rechnungen'"></app-rechnungen>
    <barcodeKundennummer *ngIf="environment.mandant_id == '111374-zcatering'"></barcodeKundennummer>
  </div>
</div>
